import React from 'react';

const SidebarIcon: React.FC = () => (
    <svg width="30" height="25" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="28" height="23" rx="2" stroke="black" strokeWidth="2"/>
        <rect x="1" y="1" width="15" height="23" rx="2" stroke="black" strokeWidth="2"/>
        <circle cx="8" cy="10" r="3" stroke="black" strokeWidth="2"/>
    </svg>
);

export default SidebarIcon;